import React from 'react';

import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import './styles.css';

import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";

import OriginalCheckboxTree from 'react-checkbox-tree'


export const CheckboxTree = ({...props}) => {
    return <OriginalCheckboxTree
        {...props}
        icons={{
            check: <CheckBoxIcon/>,
            uncheck: <CheckBoxOutlineBlankIcon/>,
            expandClose: <ArrowRightIcon/>,
            expandOpen: <ArrowDropDownIcon/>,
            halfCheck: <IndeterminateCheckBoxIcon/>,
            leaf: <span/>,
            collapseAll: <span/>,
            parentClose: <span/>,
            parentOpen: <span/>,
        }}
    />
}